import "./utils/acquisitionTracking";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./assets/css/styles.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import axios from "axios";
import { getLocalStorageItem } from "./utils/localStorage";
import { ErrorBoundary } from "react-error-boundary";
import { decryptResponse, encryptRequest } from "./utils/encryption";
import { Toaster } from "react-hot-toast";
import { errorToast } from "./utils/makeToast";
import { extractTextFromHtml } from "./utils/helpers";
import ErrorFallback from "./Components/ErrorPage/ErrorFallback";
// THE LINE BELOW DISABLES CONSOLE LOG
console.log = () => {};

axios.interceptors.request.use((request: any) => {
  let token = getLocalStorageItem("accessToken");

  request.headers!.Accept = "application/json; charset=utf-8";

  // Only set JSON Content-Type for non-FormData requests
  if (!(request.data instanceof FormData)) {
    request.headers!["Content-Type"] = "application/json; charset=utf-8";
  }

  request.headers!["Cache-Control"] = "no-store";
  request.headers!.Pragma = "no-cache";

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  request.data = encryptRequest(request.data);

  return request;
});

axios.interceptors.response.use(
  (res) => {
    return {
      ...res,
      data: decryptResponse(res.data),
    };
  },
  (error) => {
    if (error?.message) {
      const message = error?.message;

      error.response.data = { message };
      return Promise.reject(error);
    }
    const statusCode = error?.response?.status;

    // ✅ Handle server errors (5xx)
    if (statusCode >= 500) {
      const message =
        typeof error.response?.data === "string"
          ? extractTextFromHtml(error.response.data)
          : error.response?.data?.message || "Something went wrong";
      error.response.data = { message };
      return Promise.reject(error);
    }

    // ✅ Handle client / validation errors
    if (error?.response?.data) {
      const decryptedResponse = decryptResponse(error.response.data);
      const { message, error: errorText, title } = decryptedResponse || {};

      const apiError = message || errorText || title;
      if (apiError) {
        errorToast(apiError);
      }

      // Normalize error shape
      return Promise.reject({
        ...error,
        response: {
          ...error.response,
          data: decryptedResponse,
        },
      });
    }

    // Fallback
    return Promise.reject(error);
  },
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={window.location.reload}
      >
        <App />
        <Toaster />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
